const PostsActions = {
    FETCH_POSTS: 'FETCH_POSTS',
    FETCH_POSTS_SUCCESS: 'FETCH_POSTS_SUCCESS',
    FETCH_POSTS_ERROR: 'FETCH_POSTS_ERROR',
}

const SearchActions = {
    INIT: 'INIT',
    INIT_SUCCESS: 'INIT_SUCCESS',
    INIT_ERROR: 'INIT_ERROR',

    INIT_DEMO: 'INIT_DEMO',
    INIT_DEMO_SUCCESS: 'INIT_DEMO_SUCCESS',

    INITIAL_SEARCH: 'INITIAL_SEARCH',
    APPENDING_SEARCH: 'APPENDING_SEARCH',
    RELATED_SEARCH: 'RELATED_SEARCH',
    RELATED_SEARCH_FILTERED: 'RELATED_SEARCH_FILTERED',
    FILTERED_SEARCH: 'FILTERED_SEARCH',
    INITIAL_SEARCH_SUCCESS: 'INITIAL_SEARCH_SUCCESS',
    APPENDING_SEARCH_SUCCESS: 'APPENDING_SEARCH_SUCCESS',
    FILTERED_SEARCH_SUCCESS: 'FILTERED_SEARCH_SUCCESS',
    RELATED_SEARCH_SUCCESS: 'RELATED_SEARCH_SUCCESS',
    RELATED_SEARCH_FILTERED_SUCCESS: 'RELATED_SEARCH_FILTERED_SUCCESS',

    SEARCH_STARTED: 'SEARCH_STARTED',
    SET_SEARCH_TERM: 'SET_SEARCH_TERM',
    CLEAR_SEARCH_TERM: 'CLEAR_SEARCH_TERM',
    ADD_TAG: 'ADD_TAG',
    REMOVE_TAG: 'REMOVE_TAG',
    REMOVE_RANGE_TAG: 'REMOVE_RANGE_TAG',
    ADD_CATEGORY: 'ADD_CATEGORY',
    REMOVE_CATEGORY: 'REMOVE_CATEGORY',
    CLEAR_CATEGORIES: 'CLEAR_CATEGORIES',
    UPDATE_CATEGORY_TAGS: 'UPDATE_CATEGORY_TAGS',
    UPDATE_CATEGORY_SELECTION: 'UPDATE_CATEGORY_SELECTION',
    SET_SEARCH_RELATED: 'SET_SEARCH_RELATED',
    SET_SELECTED: 'SET_SELECTED',
    CLEAR_SELECTED: 'CLEAR_SELECTED',
    CLEAR_STATE: 'CLEAR_STATE',
    SET_URL: 'SET_URL',
    RESET_SEARCH: 'RESET_SEARCH',


    SEARCH_ERROR: 'SEARCH_ERROR',
    UPDATE_FILTER_VALUES: 'UPDATE_FILTER_VALUES',
    UPDATE_FILTER_RANGE: 'UPDATE_FILTER_RANGE',
    FETCH_DETAILS: 'FETCH_DETAILS',
    FETCH_DETAILS_SUCCESS: 'FETCH_DETAILS_SUCCESS',
    FETCH_DETAILS_ERROR: 'FETCH_DETAILS_ERROR',

    FETCH_PARENT_DETAILS: 'FETCH_PARENT_DETAILS',
    FETCH_PARENT_DETAILS_SUCCESS: 'FETCH_PARENT_DETAILS_SUCCESS',
    FETCH_PARENT_DETAILS_ERROR: 'FETCH_PARENT_DETAILS_ERROR',
    CLEANUP_PARENT_DETAILS: 'CLEANUP_PARENT_DETAILS',

    FETCH_DIGITAL_OBJECT_SOURCE_PATHS: 'FETCH_DIGITAL_OBJECT_SOURCE_PATHS',
    FETCH_DIGITAL_OBJECT_SOURCE_PATHS_SUCCESS: 'FETCH_DIGITAL_OBJECT_SOURCE_PATHS_SUCCESS',
    FETCH_DIGITAL_OBJECT_SOURCE_PATHS_ERROR: 'FETCH_DIGITAL_OBJECT_SOURCE_PATHS_ERROR',

    FETCH_DOS: 'FETCH_DOS',
    FETCH_DOS_SUCCESS: 'FETCH_DOS_SUCCESS',
    FETCH_DOS_ERROR: 'FETCH_DOS_ERROR',

    SET_PAGE: 'SET_PAGE',
    SET_PAGE_SIZE: 'SET_PAGE_SIZE',
    SET_SCROLLED_DOWN: 'SET_SCROLLED_DOWN',

    SET_DOWNLOAD_STATUS: 'SET_DOWNLOAD_STATUS',

    SET_GEO_FILTER: 'SET_GEO_FILTER',
    CLEAR_GEO_FILTER: 'CLEAR_GEO_FILTER',

    CHILDREN_GEO_SEARCH: 'CHILDREN_GEO_SEARCH',
    CHILDREN_GEO_SEARCH_SUCCESS: 'CHILDREN_GEO_SEARCH_SUCCESS',
    CHILDREN_GEO_SEARCH_ERROR: 'CHILDREN_GEO_SEARCH_ERROR',

    FILTER_MAP_BY_RELATIONS: 'FILTER_MAP_BY_RELATIONS',
    CLEAR_RELATIONS_FILTER: 'CLEAR_RELATIONS_FILTER',

    SET_SORT: 'SET_SORT',
}

const SettingsActions = {
    FETCH_CATEGORIES: 'FETCH_CATEGORIES',
    FETCH_CATEGORIES_SUCCESS: 'FETCH_CATEGORIES_SUCCESS',
    FETCH_CATEGORIES_ERROR: 'FETCH_CATEGORIES_ERROR',

    FETCH_ATTRIBUTES: 'FETCH_ATTRIBUTES',
    FETCH_ATTRIBUTES_SUCCESS: 'FETCH_ATTRIBUTES_SUCCESS',
    FETCH_ATTRIBUTES_ERROR: 'FETCH_ATTRIBUTES_ERROR',

    TOGGLE_SHOW_STATUS: 'TOGGLE_SHOW_STATUS',
    SET_AWESOME_VIEW: 'SET_AWESOME_VIEW',
    SET_PROJECTS_TERM: 'SET_PROJECTS_TERM',
    ADD_PROJECT_TAG: 'ADD_PROJECTS_TAG',
    FETCH_PROJECTS: 'FETCH_PROJECTS',
    FETCH_PROJECTS_SUCCESS: 'FETCH_PROJECTS_SUCCESS',
    FETCH_PROJECTS_ERROR: 'FETCH_PROJECTS_ERROR',
}

const NotificationsActions = {
    ADD_NOTIFICATION: 'ADD_NOTIFICATION',
    REMOVE_NOTIFICATION: 'REMOVE_NOTIFICATION',
}

const BasketActions = {
    ADD_TO_BASKET: 'ADD_TO_BASKET',
    REMOVE_FROM_BASKET: 'REMOVE_FROM_BASKET',
    ADD_TO_FAVORITES: 'ADD_TO_FAVORITES',
    REMOVE_FROM_FAVORITES: 'REMOVE_FROM_FAVORITES',
    TOGGLE_FAVORITE: 'TOGGLE_FAVORITE',
    ADD_TO_DOWNLOADS: 'ADD_TO_DOWNLOADS',
    REMOVE_FROM_DOWNLOADS: 'REMOVE_FROM_DOWNLOADS',

    START_DOWNLOAD_REQUEST: 'START_DOWNLOAD_REQUEST',
    DOWNLOAD_REQUEST_SUCCESS: 'DOWNLOAD_REQUEST_SUCCESS',
    DOWNLOAD_REQUEST_ERROR: 'DOWNLOAD_REQUEST_ERROR',
    CLEAR_DOWNLOAD_REQUEST_ERROR: 'CLEAR_DOWNLOAD_REQUEST_ERROR',

    CLEAR_BASKET: 'CLEAR_BASKET',
    CLEAR_STATUS_CODE: 'CLEAR_STATUS_CODE',

    CHECK_DO_AVAILABILITY: 'CHECK_DO_AVAILABILITY',
    CHECK_DO_AVAILABILITY_SUCCESS: 'CHECK_DO_AVAILABILITY_SUCCESS',
    CHECK_DO_AVAILABILITY_ERROR: 'CHECK_DO_AVAILABILITY_ERROR',
}

const DialogActions = {
    SHOW_DIALOG: 'SHOW_DIALOG',
    HIDE_DIALOG: 'HIDE_DIALOG',
    REPEAT_DIALOG: 'REPEAT_DIALOG',
}

export { PostsActions, SearchActions, NotificationsActions, SettingsActions, BasketActions, DialogActions }